import React from "react";
import AuthRouter from "./routes/AuthRouter";
import { ThemeProvider } from "@material-ui/core/styles";
import { GlobalTheme } from "./themes/GlobalTheme";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import useInitApp from "./hooks/useInitApp.hook";

// wrap AuthRouter in MuiPickerUtilsProvider https://material-ui-pickers.dev/getting-started/installation

const App = () => {
  const isInitialized = useInitApp();

  if (!isInitialized) {
    return null;
  }

  return (
    <ThemeProvider theme={GlobalTheme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <AuthRouter />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};

export default App;
